// extracted by mini-css-extract-plugin
module.exports = {"inputFieldWrapper":"styles_inputFieldWrapper__12BSu","inputField":"styles_inputField__E8xYx","counter":"styles_counter__1Ao_6","close":"styles_close__2FUx1"};